import * as _ from 'underscore';

import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';

declare var require: any;

var template = require('!!raw-loader!pdc-widget-html/src/mainTheme.template.css');

template;

declare var Color: any;
declare var pdc: any;

var _init = [];

export function init(glob) {
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    widgetTheme(glob);
    /*
        appTheme.registerSections([
            {
                id: 'pdc-widget-html',
                name: 'HTML Container',
                parent: 'widget',
    
                themeType: 'HTML Container',
                visibility: ['application', 'workspace', 'pdc-widget-html']
            }
        ]);
    
        appTheme.registerVars([
            {
                id: 'pdc-widget-html-document-mode',
                param: new SelectField(glob, 'Document Mode', [], 'Article', {
                    values: ['Article', 'Document'],
                    display: ['Inline Mode', 'Print Preview Mode']
                }),
                section: 'pdc-widget-html'
            },
    
            {
                id: 'pdc-widget-html-page-size',
                param: new SelectField(this.glob, 'Page Size', [], 'A4', {
                    values: ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'Legal', 'Letter', 'Tabloid'],
                    display: ['A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'Legal', 'Letter', 'Tabloid']
                }),
                section: 'pdc-widget-html'
            },
    
            {
                id: 'pdc-widget-html-page-orientation',
                param: new SelectField(this.glob, 'Page Orientation', [], 'portrait', {
                    values: ['portrait', 'landscape'],
                    display: ['Portrait', 'Landscape']
                }),
                section: 'pdc-widget-html'
            },
    
            //LL: 12.01.21:
            {
                id: 'pdc-widget-html-reset-layout-after-config',
                param: new BooleanField(
                    this.glob,
                    'Reset local Page Layout after Saving of updated Configuration',
                    [],
                    true
                ),
                section: 'pdc-widget-html'
            }
        ]);
    
        // appTheme.registerTemplate(
        //     template,
        //     [
        //         'pdc-widget-html'
        //     ]
        // );
    */
    _init.push(glob);
}
